import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_CONFIRM_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import { getConfirmationModal } from '@commons/Modals/ConfirmationModal';

export const getReassignmentConfirmationModalConfig = ({ handleCloseCleanUp, handleConfirm }) => ({
  ...getConfirmationModal({
    title: i18next.t('ADMIN.RECIPES.VARIANT_MODAL.REASSIGN_CONFIRM_TITLE'),
    icon: '/images/inpulse/warning-white-small.svg',
    content: i18next.t('ADMIN.RECIPES.VARIANT_MODAL.REASSIGN_CONFIRM_CONTENT'),
    actions: [
      GENERIC_MODAL_CANCEL_BUTTON(),
      {
        ...GENERIC_MODAL_CONFIRM_BUTTON(),
        handleClick: handleConfirm,
      },
    ],
  }),
  handleCloseCleanUp,
});
